import React from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from '../hooks/useTranslation'
import { useLanguage } from '../contexts/LanguageContext'
import { usePageSeo } from '../hooks/usePageSeo'
import ModalitiesRatesChart from '../components/ModalitiesRatesChart.jsx'

const ModalitiesRates = () => {
  const t = useTranslation()
  const { isLoading } = useLanguage()
  const location = useLocation()

  usePageSeo({
    enabled: !isLoading,
    title: `${t('modalitiesRates.meta.title')} | VIVA Psychotherapy`,
    description: t('modalitiesRates.meta.description'),
    pathname: location.pathname
  })

  if (isLoading) {
    return (
      <div className="min-h-screen bg-primary-offWhite flex items-center justify-center">
        <div className="animate-pulse text-gray-500">Loading…</div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-primary-offWhite">
      <article className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14 lg:py-16">
        <header className="text-center mb-10 sm:mb-12">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-primary-darkGreen tracking-tight">
            {t('modalitiesRates.pageTitle')}
          </h1>
        </header>

        <ModalitiesRatesChart />
      </article>
    </div>
  )
}

export default ModalitiesRates
